import React from 'react'

interface StepperProps {
  currentActiveStep?: number
  steps: React.ReactNode[]
}

const Stepper: React.FC<StepperProps> = ({ currentActiveStep, steps }) => {
  return steps[currentActiveStep ?? 0]
}

export default Stepper
